import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Grid } from '../../lib/grid';
import { Cell } from '../../lib/data-set/cell';
import { Row } from '../../lib/data-set/row';

@Component({
    selector: 'ng2-smart-table-cell',
    template: `
      @if (!isInEditing) {
        <table-cell-view-mode (linkClickEvent)="linkClickEvent.emit($event)"
                              [cell]="cell">
        </table-cell-view-mode>
      }
      @if (isInEditing) {
        <table-cell-edit-mode [cell]="cell"
                              [inputClass]="inputClass"
                              (edited)="onEdited($event)"
                              (blur)="onBlur($event)">
        </table-cell-edit-mode>
      }
    `,
    standalone: false
})
export class CellComponent {
  @Input() public grid: Grid;
  @Input() public row: Row;
  @Input() public editConfirm: EventEmitter<any>;
  @Input() public createConfirm: EventEmitter<any>;
  @Input() public isNew: boolean;
  @Input() public cell: Cell;
  @Input() public inputClass: string = '';
  @Input() public mode: string = 'inline';
  @Input() public isInEditing: boolean = false;

  @Output() public edited = new EventEmitter<any>();
  @Output() public blur = new EventEmitter<any>();
  @Output() public linkClickEvent = new EventEmitter<any>();

  public onEdited(event: any) {
    if (this.isNew) {
      this.grid.create(this.grid.getNewRow(), this.createConfirm);
    } else {
      this.grid.save(this.row, this.editConfirm);
    }
  }

  public onBlur(event: any) {
    if (this.row.isNewRow) {
      this.blur.emit(event);
    }
  }
}
